
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"17.467","height":"23.203","viewBox":"0 0 17.467 23.203"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"id":"marker","transform":"translate(-17.801 94.681)"}},[_c('path',{attrs:{"id":"Path_189809","data-name":"Path 189809","d":"M35.239-86.659a8.75,8.75,0,0,0-8.082-8A8.747,8.747,0,0,0,17.8-85.926a8.587,8.587,0,0,0,1.492,4.882c1.139,1.681,4.393,6.427,6.13,8.977a1.343,1.343,0,0,0,2.224,0c1.735-2.522,4.989-7.295,6.13-8.977a8.648,8.648,0,0,0,1.464-5.615Zm-8.706,5.723a5.023,5.023,0,0,1-5.017-5.017,5.023,5.023,0,0,1,5.017-5.017,5.023,5.023,0,0,1,5.017,5.017A5.023,5.023,0,0,1,26.533-80.936Z","transform":"translate(0 0)","fill":"#fff500"}})])])
          )
        }
      }
    